import ComidaImage from "../../../../../src/assets/platoComida.webp";

export const ItemComida = ({ comida, onClick, idSelected, fechaValue }) => {
  //card de comida
  const isSelected = idSelected === comida.pre_comida_id;

  const havePreDetalleComida =
    comida?.pre_detalle_comida?.filter(
      (item) => item.fecha_menu === fechaValue
    )[0] ?? null;
  return (
    <div
      className="border rounded-2 p-2"
      onClick={onClick}
      style={{
        background: isSelected ? "#d0d0d0" : "",
        cursor: isSelected ? "default" : "pointer",
        transition: "all 0.3s ease-in-out",
      }}
    >
      <div className="row align-items-center justify-content-between">
        {!havePreDetalleComida && (
          <small className="text-danger">Sin menu</small>
        )}
        <div className="col-md-6">
          <h5>{comida.nombre}</h5>
          {/* <p className="text-muted ">${comida.costo}</p> */}
        </div>
        <img
          src={comida.imagen ? comida.imagen : ComidaImage}
          alt="plato comida"
          style={{ width: "70px", height: "50px", borderRadius: "50%" }}
        />
      </div>
    </div>
  );
};
